import React, { useState } from 'react'
import Wait from '@react/react-spectrum/Wait'
import ReactCompareImage from '../Nav/ReactCompareImage' // our custom changes to support onLoad
import { __ } from 'i18n-for-browser'
import '../../config/i18n'

export default function CompareImage ({
    before, after,
    beforeCaption = __('image_original'),
    afterCaption = __('image_edited'),
    handleSize = 14,
    spinnerCaption
}) {
    const [wait, setWait] = useState({ wait: true })
    return (
        <React.Fragment>
            <ReactCompareImage
                beforeCaption={ beforeCaption }
                afterCaption={ afterCaption }
                leftImage={ before }
                rightImage={ after }
                handleSize={ handleSize }
                handle={<button aria-label={__('label_compare_images')}  className="adobe-easybake-react-compare-image-handle" />}
                onLoad={() => setWait(false)}
            />
            {/* <div className="adobe-easybake-image-label-left"><p>{beforeCaption}</p></div>
            <div className="adobe-easybake-image-label-right"><p>{afterCaption}</p></div> */}
            {wait &&
            <div className="spinner">
                <Wait centered variant="overBackground" />
                <div className="caption">
                    {spinnerCaption}
                </div>
            </div>
            }
        </React.Fragment>
    )
}
